var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3127 1.63328C15.7791 1.63328 16.1572 2.00379 16.1572 2.46083C16.1572 2.87979 15.8395 3.22603 15.4273 3.28083L15.3127 3.28838H7.12962C4.36577 3.28838 2.58776 5.08198 2.48557 7.87981L2.48091 8.13691V17.055C2.48091 19.9266 4.15123 21.7819 6.87877 21.8886L7.12962 21.8934H16.8174C19.5837 21.8934 21.3594 20.1068 21.4615 17.3119L21.4661 17.055V9.28828C21.4661 8.83124 21.8442 8.46073 22.3106 8.46073C22.7381 8.46073 23.0914 8.77206 23.1473 9.17599L23.155 9.28828V17.055C23.155 20.7959 20.7451 23.424 17.0812 23.5442L16.8174 23.5485H7.12962C3.37954 23.5485 0.908916 21.0217 0.796031 17.3213L0.791992 17.055V8.13691C0.791992 4.39419 3.20328 1.75818 6.86589 1.6376L7.12962 1.63328H15.3127ZM17.6953 9.1694C18.0305 9.42389 18.1166 9.87662 17.9148 10.2283L17.8456 10.3304L14.5477 14.5016C14.2868 14.8316 13.822 14.915 13.4628 14.7143L13.3585 14.6456L10.1846 12.2026L7.33512 15.8326C7.07658 16.1619 6.61489 16.2478 6.25538 16.0513L6.15089 15.9838C5.81486 15.7305 5.72721 15.278 5.92773 14.9257L5.99657 14.8233L9.36667 10.5309C9.62706 10.1993 10.093 10.1148 10.4531 10.3159L10.5576 10.3848L13.7324 12.8293L16.5106 9.31671C16.7962 8.95542 17.3267 8.88947 17.6953 9.1694ZM21.0223 0.704102C22.684 0.704102 24.031 2.02419 24.031 3.65261C24.031 5.28102 22.684 6.60111 21.0223 6.60111C19.3606 6.60111 18.0135 5.28102 18.0135 3.65261C18.0135 2.02419 19.3606 0.704102 21.0223 0.704102ZM21.0223 2.3592C20.2934 2.3592 19.7025 2.93828 19.7025 3.65261C19.7025 4.36693 20.2934 4.94601 21.0223 4.94601C21.7512 4.94601 22.3421 4.36693 22.3421 3.65261C22.3421 2.93828 21.7512 2.3592 21.0223 2.3592Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15_2115",
    x1: 12.4115,
    y1: 0.704102,
    x2: 12.4115,
    y2: 23.5485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5C4FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD1F5",
    stopOpacity: 0.44
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboard);
export default __webpack_public_path__ + "static/media/onboard.982d678ecee92df0b1624f1b8bf95ae3.svg";
export { ForwardRef as ReactComponent };